import { displayDigits } from './displayDigits';

/** Localize planning copy, including catalogs delivered by the server. */
export function planningDisplayText(value: string | number, locale?: string): string {
  let text = String(value);
  if (/^fa(?:-|$)/i.test(locale ?? '')) {
    text = text.replace(/\bCTL\b/g, 'آمادگی').replace(/\bTSS\b/g, 'بار تمرینی')
      .replace(/بار تمرینی هفتگی/g, 'بار تمرینی هفته');
  }
  return displayDigits(text, locale);
}
